import { render, staticRenderFns } from "./AddAdress.vue?vue&type=template&id=3bd12af7&scoped=true&"
import script from "./AddAdress.vue?vue&type=script&lang=js&"
export * from "./AddAdress.vue?vue&type=script&lang=js&"
import style0 from "./AddAdress.vue?vue&type=style&index=0&id=3bd12af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd12af7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd12af7')) {
      api.createRecord('3bd12af7', component.options)
    } else {
      api.reload('3bd12af7', component.options)
    }
    module.hot.accept("./AddAdress.vue?vue&type=template&id=3bd12af7&scoped=true&", function () {
      api.rerender('3bd12af7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddAdress.vue"
export default component.exports